import React from 'react';
import { Provider } from 'react-redux';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import '@amplify/amplify-styles/dist/assets/toolkit/styles-release/amplify-base.css';
import KeycloakProvider from './api/keycloak/KeycloakProvider';
import store, { history } from './configureStore';
import SfChatWrapper from './components/sfChat/shared/sfChatWrapper';
import KeycloakTrackerContainer from './providers/user/shared/KeycloakTrackerContainer';
import './styles/overrides.scss';
import './styles/common.scss';
import config from './configs/master';

const DemoModeHeaderContainer = config.demoHeaderContainer;
const DemoToolTipsContainer = config.demoToolTipsContainers;
const HeaderContainer = config.headerContainer;
const AppLayout = config.appLayout;
const PdfGenerationContainer = config.pdfGenerationContainer;
const ErrorViewContainer = config.errorViewContainer;
const AmpNavContainer = config.ampNavContainer;

const App = () => (
    <KeycloakProvider>
        <Provider store={store}>
            <KeycloakTrackerContainer>
                <div className="mclass-benchmark">
                    <ErrorViewContainer />
                    <PdfGenerationContainer />
                    <DemoModeHeaderContainer />
                    <DemoToolTipsContainer />
                    <AmpNavContainer />
                    <Router history={history}>
                        <HeaderContainer />
                        <AppLayout />
                    </Router>
                </div>
                <SfChatWrapper />
            </KeycloakTrackerContainer>
        </Provider>
    </KeycloakProvider>
);

export default App;
